<template>
<div class="chapter">
<div class="inner_page">
<div>
<p class="dedication"><em class="italic">For Linda, Pamela, and Sunyata</em></p>
<figure class="divider">
<img alt="" class="sec-div" src="image/divider.png"/>
</figure>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Dedication.vue?5155437e